module.exports = __webpack_public_path__ + "static/media/Header.c57e96b3.svg";